import SuppressionReason from './SuppressionReason'
import OrderMethod from './OrderMethod'
export class SuppressInfo {
    RequestID: number;
    SuppressCustomer: boolean;
    SuppressionReasonID?: number;
    SuppressionReason?: SuppressionReason;
    UnsuppressCustomer: boolean;
    OwnershipChange: boolean;
    OrderMethodID?: number;
    OrderMethod?: OrderMethod;
}

export default SuppressInfo;